import { useEffect, useRef } from "react";

import type { ProcessedSelection } from "@/hooks/firestore/betting/useEntries";
import type { MysteryMulti } from "@/features/sem-generator/util/constants";

import { useEvent } from "@/hooks/firestore/betting/useEvent";
import { useToggleSelection } from "@/features/betslip/hooks/useToggleSelection";
import { buildSharePickInput } from "../util/share-toggle-inputs";

/**
 * Adds a shared entry's pick to the betslip once the live event loads.
 * Quaddies go through ShareQuaddie instead — they carry their own market
 * document.
 */
export const useAutoAddPickToBetslip = (
  selection: ProcessedSelection,
  addToSlip = true,
  onComplete?: () => void,
  mysteryMulti?: MysteryMulti,
) => {
  const { event } = useEvent(selection.event.eventId, "all");
  const { toggle } = useToggleSelection();
  const hasBeenAdded = useRef(false);

  useEffect(() => {
    if (!addToSlip || hasBeenAdded.current) return;
    if (!event) return;

    const input = buildSharePickInput(event, selection, mysteryMulti);
    if (!input) return;

    toggle(input);
    onComplete?.();
    hasBeenAdded.current = true;
  }, [addToSlip, event, selection, toggle, mysteryMulti]);
};
